import { ChangeDetectionStrategy, Component, inject, Input, OnDestroy } from '@angular/core';
import { AsyncPipe, CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';
import { LineTripSearchResult, TripSearchResult } from '../../interfaces';
import { TrafficDeviationSearchStore } from '@components/traffic-deviations/components/searches';

@Component({
    selector: 'app-trips',
    imports: [CommonModule, AsyncPipe, TranslateModule],
    templateUrl: './trips.component.html',
    styleUrls: ['./trips.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TripsComponent implements OnDestroy {
  private _searchStore = inject(TrafficDeviationSearchStore);

  @Input() set lineId (lineId: string)  {
    this._searchStore.getSelectedRoutes().pipe(
      takeUntil(this._destroy$)
    ).subscribe((selectedRoutes) => {
      this.selectedRoute$.next(selectedRoutes.find((route) => route.lineId === lineId));
    });
  }


  constructor() { }

  protected selectedRoute$ = new BehaviorSubject<Readonly<LineTripSearchResult>>(undefined);

  private _destroy$ = new Subject<void>();

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  protected onChangeSelectTrip(trip: Readonly<TripSearchResult>): void {
    const selectedRoute = {...this.selectedRoute$.value};
    const tripIndex = selectedRoute.trips.findIndex(({tripNumber}) => tripNumber === trip.tripNumber);
    if (tripIndex === -1) return;

    trip = {...trip, selected: !trip.selected};
    const trips = [...selectedRoute.trips];
    trips.splice(tripIndex, 1, trip);
    selectedRoute.trips = trips;

    const selectedRoutes = [...this._searchStore.stateSnapshot.selectedRoutes];
    const routeIndex = selectedRoutes.findIndex(({lineId}) => lineId === selectedRoute.lineId);
    selectedRoutes.splice(routeIndex, 1, selectedRoute);
    this._searchStore.updateSearchState({selectedRoutes});
  }
}